import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import router from './router/router.tsx';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './locale/translations.ts';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/context/AuthContext.tsx';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
// import * as Sentry from '@sentry/react';
import '@fontsource-variable/inter';
import 'react-day-picker/src/style.css';
import './index.css';
import { ThemeProvider } from '@/context/ThemeContext.tsx';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

dayjs.extend(utc);

i18n.use(initReactI18next).init({
  resources: translations,
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export const queryClient = new QueryClient();
//
// Sentry.init({
//   dsn: import.meta.env.VITE_SENTRY_DSN,
//   integrations: [
//     Sentry.captureConsoleIntegration({
//       levels: ['error'],
//     }),
//   ],
// });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <RouterProvider router={router} />
          <ToastContainer 
            position="top-right" 
            autoClose={3000}
            closeOnClick
            pauseOnHover
            draggable
            hideProgressBar={false}
            theme="colored"
            style={{
              ['--toastify-icon-color-success' as string]: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%2300A96E\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpath d=\'M22 11.08V12a10 10 0 1 1-5.93-9.14\'/%3E%3Cpolyline points=\'22 4 12 14.01 9 11.01\'/%3E%3C/svg%3E") no-repeat center center / contain',
              '--toastify-color-progress-success': '#00A96E',
              '--toastify-color-success': '#00A96E',
            } as React.CSSProperties}
          />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>
);
